{
  "cycle.entite.catalogue_dependances_figees": "Frozen dependencies of published versions",
  "cycle.entite.catalogue_revision_contributeurs": "Catalogue revision contributors",
  "cycle.entite.catalogue_revisions": "Organisation catalogue revisions",
  "journalAudit.action.agent.promotion_validated": "Agent promotion validated (v10 cycle)",
  "journalAudit.action.catalogue.agent.duplicated": "Agent duplicated as a draft",
  "journalAudit.action.catalogue.agent.published": "Agent published",
  "journalAudit.action.catalogue.agent.refused": "Agent refused with a reason",
  "journalAudit.action.catalogue.agent.retired": "Published agent retired",
  "journalAudit.action.catalogue.agent.submitted": "Agent submitted for validation",
  "journalAudit.action.catalogue.agent.validated": "Agent validated by another person",
  "journalAudit.action.catalogue.agent.withdrawn": "Agent withdrawn from validation",
  "journalAudit.action.catalogue.modele.duplicated": "Model duplicated as a draft",
  "journalAudit.action.catalogue.modele.published": "Model published",
  "journalAudit.action.catalogue.modele.refused": "Model refused with a reason",
  "journalAudit.action.catalogue.modele.submitted": "Model submitted for validation",
  "journalAudit.action.catalogue.modele.validated": "Model validated by another person",
  "journalAudit.action.catalogue.modele.withdrawn": "Model withdrawn from validation",
  "journalAudit.action.catalogue.relation.duplicated": "Relation duplicated as a draft",
  "journalAudit.action.catalogue.relation.published": "Relation published",
  "journalAudit.action.catalogue.relation.refused": "Relation refused with a reason",
  "journalAudit.action.catalogue.relation.retired": "Published relation retired",
  "journalAudit.action.catalogue.relation.submitted": "Relation submitted for validation",
  "journalAudit.action.catalogue.relation.validated": "Relation validated by another person",
  "journalAudit.action.catalogue.relation.withdrawn": "Relation withdrawn from validation",
  "journalAudit.action.catalogue.type_artefact.duplicated": "Artifact type duplicated as a draft",
  "journalAudit.action.catalogue.type_artefact.published": "Artifact type published",
  "journalAudit.action.catalogue.type_artefact.refused": "Artifact type refused with a reason",
  "journalAudit.action.catalogue.type_artefact.retired": "Published artifact type retired",
  "journalAudit.action.catalogue.type_artefact.submitted": "Artifact type submitted for validation",
  "journalAudit.action.catalogue.type_artefact.validated": "Artifact type validated by another person",
  "journalAudit.action.catalogue.type_artefact.withdrawn": "Artifact type withdrawn from validation"
}
